import { render, staticRenderFns } from "./AllScore.vue?vue&type=template&id=6e0f4cca&scoped=true&"
import script from "./AllScore.vue?vue&type=script&lang=js&"
export * from "./AllScore.vue?vue&type=script&lang=js&"
import style0 from "./AllScore.vue?vue&type=style&index=0&id=6e0f4cca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0f4cca",
  null
  
)

export default component.exports